import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
@Injectable({
	providedIn: 'root'
})
export class EducationService {
	constructor(public http: HttpClient) { }
	public getPucaFormDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PUCA + 'das/getInitFormData')
	}

	public saveOrUpdateEducation(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'cpEducation/updateEducationDetails', payload)
	}
}